import {
  AssociatedEntityFilterInput,
  FilterInput,
  useLocationsListLazyQuery,
} from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils';
import { useMemo } from 'react';

export const useLocationsDataSource = (
  filters?: FilterInput[],
  associatedEntityFilters?: AssociatedEntityFilterInput[]
): DataSource<FormOption[]> => {
  const [getLocationsList] = useLocationsListLazyQuery({
    variables: { limit: 10_000, filters, associatedEntityFilters },
  });

  return useMemo(
    () => ({
      load: async () => {
        const { data } = await getLocationsList();

        return getNodes(data?.locations)
          .filter(({ id }) => id !== null)
          .map(({ id, details }) => ({
            label: details.name,
            value: id,
          }));
      },
    }),
    [getLocationsList]
  );
};
